import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  id: "Layer_2",
  "enable-background": "new 0 0 24 24",
  viewBox: "0 0 24 24",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", { d: "m9 10c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zm0-9c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z" })
    ], -1),
    _createElementVNode("g", null, [
      _createElementVNode("path", { d: "m9.08 21h-8.58c-.276 0-.5-.224-.5-.5v-4c0-2.481 2.019-4.5 4.5-4.5h5.76c.276 0 .5.224.5.5s-.224.5-.5.5h-5.76c-1.93 0-3.5 1.57-3.5 3.5v3.5h8.08c.276 0 .5.224.5.5s-.224.5-.5.5z" })
    ], -1),
    _createElementVNode("g", null, [
      _createElementVNode("path", { d: "m17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12c-3.032 0-5.5 2.468-5.5 5.5s2.468 5.5 5.5 5.5 5.5-2.468 5.5-5.5-2.468-5.5-5.5-5.5z" })
    ], -1),
    _createElementVNode("g", null, [
      _createElementVNode("path", { d: "m19.5 20c-.128 0-.256-.049-.354-.146l-2-2c-.093-.094-.146-.221-.146-.354v-3c0-.276.224-.5.5-.5s.5.224.5.5v2.793l1.854 1.854c.195.195.195.512 0 .707-.098.097-.226.146-.354.146z" })
    ], -1)
  ])))
}